import { render, staticRenderFns } from "./OrderShop.vue?vue&type=template&id=25821cde&scoped=true"
import script from "./OrderShop.vue?vue&type=script&lang=js"
export * from "./OrderShop.vue?vue&type=script&lang=js"
import style0 from "./OrderShop.vue?vue&type=style&index=0&id=25821cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25821cde",
  null
  
)

export default component.exports